import React from "react";
import Typography from "@mui/material/Typography";


export const PageTitle = ({...props}) => {
    return (
        <Typography component="h1" variant="h5" sx={{mb: 3}}>
            {props.pageTitle}
        </Typography>

    )
}